
import { Component, Vue } from 'vue-property-decorator'
import UserPersonalAuthService from '@/biz/service/User/UserPersonalAuthService'

@Component
export default class ViewUserMemberPersonalAuthIndex extends Vue {
  private Service = UserPersonalAuthService
}
